export default __webpack_public_path__ + "static/media/Phone.1d5dce20.png";